import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import IcoCalendar from 'assets/images/show-hide-cal-icon.svg';
import { selectOldFlagsHideMiniModal } from 'selectors/oldFlags.selectors';

import { getClientsList, pickClient, setType } from 'booking/actions';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import { NavTabs } from 'booking/components/common/bw-header/NavTabs';
import BWContent from 'booking/components/common/BWContent';
import CloseButton from 'booking/components/common/CloseButton';
import SearchableDropdown from 'booking/components/common/SearchableDropdown';
import { closeUrl } from 'booking/utils';

class CustomerPicker extends React.Component {
  handleClick = () => {
    const el = document.querySelector('.show-hide-booking');
    if (!el) return;
    el.style.display = el.style.display === 'none' ? 'block' : 'none';
  };

  render() {
    const { setType, history, bookedByButton, addedServices, getClientsList, salonId, hideMiniModal, pickClient, location, clientList, scheduler } = this.props;

    return (
      <div>
        <span className="view-hide-booking-window" onClick={this.handleClick} role="button" tabIndex={0}>
          <img src={IcoCalendar} alt="Show / Hide create new booking" />
        </span>
        <div className="BookingWindow show-hide-booking c">
          <HeaderWrapper additionalClass="border-b">
            <NavTabs selected="booking" history={history} setType={setType} bookedByButton={bookedByButton} />
            <CloseButton history={history} disableConfirm close={closeUrl(location)} />
          </HeaderWrapper>

          <BWContent additionalClass="">
            <SearchableDropdown
              history={history}
              location={location}
              salonId={salonId}
              type="text"
              getClientsList={getClientsList}
              list={clientList}
              pickClient={(client) => {
                const { pathname } = location;

                pickClient(client);

                if (addedServices.length > 0) {
                  // We've already got added services, so jump to the summary
                  history.push(
                    `${pathname
                      .split('/')
                      .filter((str) => str !== 'select')
                      .join('/')}/summary`,
                  );
                } else {
                  let path;
                  if (hideMiniModal && scheduler.bookedByButton) {
                    path = `${pathname}/services`;
                  } else if (hideMiniModal && !scheduler.bookedByButton) {
                    path = `${pathname}services`;
                  }
                  if (!hideMiniModal) {
                    path = `${pathname}/services`;
                  }
                  history.push(path);
                }
              }}
              placeholder={`Search from ${clientList.length} clients `}
            />
          </BWContent>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ pickClient, getClientsList, setType }, dispatch);

const mapStateToProps = (state) => ({
  addedServices: state.booking.addedServices,
  bookedByButton: state.scheduler.bookedByButton,
  clientList: state.currentSalon.clientList,
  hideMiniModal: selectOldFlagsHideMiniModal(state),
  salonId: state.currentSalon.id,
  scheduler: state.scheduler,
});

const CustomerPickerHoc = connect(mapStateToProps, mapDispatchToProps)(CustomerPicker);

export default CustomerPickerHoc;
